import React from "react";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Megan R.",
    location: "Garden District, Baton Rouge",
    quote:
      "They cleaned the windows, frames, AND tracks. I've never seen our sills this spotless. Already booked them again.",
    rating: 5,
  },
  {
    name: "David T.",
    location: "Denham Springs",
    quote:
      "Punctual, polite, and the water-fed pole reached panes I thought were impossible. Worth every penny.",
    rating: 5,
  },
  {
    name: "Sarah K.",
    location: "Watson",
    quote:
      "Booked them for our whole house and the difference was night and day. Frames and tracks looked brand new. Highly recommend.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-[#00B4D8] font-bold">
            Words from our neighbors
          </span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-extrabold text-[#0B2542] leading-tight">
            5-star service, repeat customers.
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="relative rounded-3xl bg-white border border-blue-100 p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(15,76,129,0.08)]"
            >
              <Quote className="h-8 w-8 text-[#90E0EF] mb-4" />
              <div className="flex gap-1 mb-3">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star
                    key={idx}
                    className="h-4 w-4 fill-[#FFB703] text-[#FFB703]"
                  />
                ))}
              </div>
              <p className="text-slate-800 leading-relaxed">"{t.quote}"</p>
              <div className="mt-6 pt-5 border-t border-blue-50">
                <div className="font-[Outfit] font-bold text-[#0B2542]">{t.name}</div>
                <div className="text-xs text-slate-500 mt-0.5">{t.location}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
